import React from "react";
import ShipDetailsBlock from "./ShipDetailsBlock";
import ShipCreateBlock from "./ShipCreateBlock";
import { Height, LoadingBlock } from "../Blocks";
import { SalesCharter, Voyage } from "types/index";
import { getCharterTypeColor } from "view/charters/utils/CharterUtils";
import { CharterSubtype, CharterType, SalesCharterStatus } from "__generated__/enums";

type UseShipBlockProps = {
	charter?: SalesCharter;
	voyage?: Voyage;
	loading: boolean;
	refetch: () => void;
	resetShipNomination?: boolean;
};

const useShipBlock = ({ charter, voyage, loading, refetch, resetShipNomination }: UseShipBlockProps) => {
	const canLinkShip = () => {
		if (charter?.cargos == null || charter.cargos.length === 0) {
			return false;
		}
		if (charter.type === CharterType.Sales && charter.subtype === CharterSubtype.Time && charter.contract == null) {
			return false;
		}
		if (charter.status?.name === SalesCharterStatus.Cancelled) {
			return false;
		}
		return true;
	};

	return {
		shipBlock: function() {
			if (loading) {
				return (
					<LoadingBlock
						height={Height.Medium} />
				);
			} else if (charter && voyage) {
				return (
					<ShipDetailsBlock
						charter={charter}
						voyage={voyage}
						color={getCharterTypeColor(charter.purchaseCharter?.type ?? CharterType.Purchase, charter.purchaseCharter?.subtype)}
						refetch={refetch} />
				);
			} else if (charter && canLinkShip()) {
				return (
					<ShipCreateBlock
						resetShipNomination={resetShipNomination}
						charter={charter}
						refetch={refetch} />
				);
			} else {
				return (
					<React.Fragment />
				);
			}
		}(),
	};
};

export default useShipBlock;
